export const createAdminAirdropService = (api) => ({
  baseUrl: '/airdrop/admin',

  /**
   * Récupère la liste des participations à l'airdrop avec filtres et pagination.
   * @param {object} params - Les paramètres de la requête (page, limit, status, search).
   * @returns {Promise<object>} Les données des participations et la pagination.
   */
  async getAirdropParticipations(params) {
    try {
      const response = await api.get(`${this.baseUrl}/participations`, { params });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des participations à l'airdrop:", error);
      throw error;
    }
  },

  /**
   * Supprime une participation à l'airdrop.
   * @param {string} participationId - L'ID de la participation à supprimer.
   * @returns {Promise<object>} La réponse de l'API.
   */
  async deleteAirdropParticipation(participationId) {
    try {
      const response = await api.delete(`${this.baseUrl}/${participationId}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression de la participation ${participationId}:`, error);
      throw error;
    }
  },

  /**
   * Valide ou rejette le tweet d'une participation.
   * @param {string} participationId - L'ID de la participation.
   * @param {boolean} isValid - True pour valider, false pour rejeter.
   * @param {string|null} error - La raison du rejet (optionnel).
   * @returns {Promise<object>} La réponse de l'API.
   */
  async validateAirdropTweet(participationId, isValid, error = null) {
    try {
      const response = await api.post(`${this.baseUrl}/${participationId}/validate-tweet`, { isValid, error });
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la validation du tweet pour la participation ${participationId}:`, error);
      throw error;
    }
  },

  /**
   * Récupère les statistiques de l'airdrop pour le tableau de bord admin.
   * @returns {Promise<object>} Les statistiques de l'airdrop.
   */
  async getAirdropStats() {
    try {
      const response = await api.get(`${this.baseUrl}/stats`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des statistiques de l'airdrop:", error);
      throw error;
    }
  },

  /**
   * Marque une participation comme distribuée.
   * @param {string} participationId - L'ID de la participation.
   * @param {string} txHash - Le hash de la transaction de distribution.
   * @returns {Promise<object>} La réponse de l'API.
   */
  async markAsDistributed(participationId, txHash) {
    try {
      const response = await api.post(`${this.baseUrl}/${participationId}/mark-distributed`, { txHash });
      return response.data;
    } catch (error) {
      console.error(`Erreur lors du marquage de la distribution pour la participation ${participationId}:`, error);
      throw error;
    }
  }
}); 